import {Base,Axios} from "@/api/Base"

export class PaymentExportCommissionPaymentByIdSal extends Base {
    path = "payment/exportCommissionPaymentByIdSal"
    download(param = {}) {
      return Axios.get(this.path,{ params: param, responseType: "blob" })
  }
}